import styled from "styled-components";

export const LeftSidebar = styled.div`
  z-index: 100;
  width: 270px;
  min-width: 270px;
  max-width: 270px;
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
  transition: left 0.3s;
  background-color: ${({ theme }) => theme.colors.dataViz.leftSidebarBgColor};
  padding: 40px 40px;
  border-right: 1px solid #e8ecef;
  box-shadow: 0 0 20px rgba(40, 50, 58, 0.05);
  position: sticky;
  top: 0;
  overflow-y: auto;
`;
